// extracted by mini-css-extract-plugin
export default {"container":"style_container__3Eded","titleSection":"style_titleSection__4duMo"};